import { AutenticacionService, ModulosARK, TipoPermiso } from './../../services/autenticacion.service';
import { SecurityModalComponent } from './../partials/security-modal/security-modal.component';
import { ReportesService } from './../../services/reportes.service';
import { DomSanitizer } from '@angular/platform-browser';
import { HelpersService } from './../../services/tools/helpers.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ReporteDepositoGarantiaService } from '../../services/reporte-deposito-garantia.service';
import { Subscription } from 'rxjs/Subscription';
import { forkJoin } from 'rxjs/observable/forkJoin';

@Component({
  selector: 'app-reporte-deposito-garantia',
  templateUrl: './reporte-deposito-garantia.component.html',
  styleUrls: ['./reporte-deposito-garantia.component.scss']
})
export class ReporteDepositoGarantia implements OnInit {
  @ViewChild(SecurityModalComponent) securityModal: SecurityModalComponent;
  public reportes_lista: any[] = [];
  public reporte_actual: any;
  public fecha_actual: any;
  public fecha_filter: any;
  public fecha_filter_final: any;
  public proveedor_filter: any;
  public proveedor_options: any[];
  public obra_filter: any;
  public obra_options: any[];
  public securityActived: any = false;
  public loading_report: any = true;
  public show_report: any = false;
  public not_report: any = false;
  public printing: boolean = false;
  public solo_saldo_pendiente: boolean = false;

  public first_load: boolean = true;
  public changed_obra_or_proveedor: boolean = false;
  public fechaInicialLabel:string;
  public fechaFinalLabel:string;
  public fechaGeneradoLabel:string;
  public total_ingresos:string;
  public total_egresos:string;
  public saldo:string;
  public lista_depositos: any[];
  private subscriptions: Array<Subscription> = [];
  constructor(private reportesService: ReportesService,
              private reporteDepositoGarantiaService: ReporteDepositoGarantiaService,
              private helperService: HelpersService,
              private router: Router,
              private helpersService: HelpersService,
              private sanitizer: DomSanitizer, 
              private authService: AutenticacionService) { }

  ngOnInit() {
    let reportes_lista = this.reportesService.getListaReportes();
    //console.log("reportes_lista:",JSON.stringify(reportes_lista));
    for (let i = 0; i < reportes_lista.length; i++) {  
      if(reportes_lista[i]["id"] == 1 && this.authService.tienenPermisos(ModulosARK.ReportePorInversionista, TipoPermiso.Lectura)){
        this.reportes_lista.push(reportes_lista[i]);
      }
      if(reportes_lista[i]["id"] == 2 && this.authService.tienenPermisos(ModulosARK.ReporteResumenDeObra, TipoPermiso.Lectura)){
        this.reportes_lista.push(reportes_lista[i]);
      }
      if(reportes_lista[i]["id"] == 3 && this.authService.tienenPermisos(ModulosARK.ReportePorObra, TipoPermiso.Lectura)){
        this.reportes_lista.push(reportes_lista[i]);
      }
      if(reportes_lista[i]["id"] == 4 && this.authService.tienenPermisos(ModulosARK.ReporteBalanceKr, TipoPermiso.Lectura)){
        this.reportes_lista.push(reportes_lista[i]);
      }
      if(reportes_lista[i]["id"] == 5 && this.authService.tienenPermisos(ModulosARK.ReportePuntoDeEquilibrio, TipoPermiso.Lectura)){
        this.reportes_lista.push(reportes_lista[i]);
      }
      if(reportes_lista[i]["id"] == 6 && this.authService.tienenPermisos(ModulosARK.ReporteResumenDeDiferencia, TipoPermiso.Lectura)){
        this.reportes_lista.push(reportes_lista[i]);
      }
      if(reportes_lista[i]["id"] == 7 && this.authService.tienenPermisos(ModulosARK.ReporteSaldos, TipoPermiso.Lectura)){
        this.reportes_lista.push(reportes_lista[i]);
      }
      if(reportes_lista[i]["id"] == 8 && this.authService.tienenPermisos(ModulosARK.ReporteDepositoGarantia, TipoPermiso.Lectura)){
        this.reportes_lista.push(reportes_lista[i]);
        this.reporte_actual = reportes_lista[i]; //reporte de depósito en garantía
      }
      if(reportes_lista[i]["id"] == 9 && this.authService.tienenPermisos(ModulosARK.ReporteCobranza, TipoPermiso.Lectura)){
        this.reportes_lista.push(reportes_lista[i]);
      }
    }
    this.getFechaActual();
  }
  
  changeReporte(reporte) {
    if (reporte.id && reporte.id != this.reporte_actual.id) {
      this.router.navigate([reporte.ruta]);
    }
  }
  
  getObras(fecha_filter,fecha_filter_final){
    this.reporteDepositoGarantiaService.getObras(fecha_filter, fecha_filter_final)
      .subscribe(response => {
        const content_response = response.json().content;
        //console.log("getObras:",content_response);
        this.obra_options = content_response;
        if(this.obra_options.length>0){
          this.obra_filter = this.obra_options[0];
          this.getProveedores(this.obra_filter,fecha_filter,fecha_filter_final);
        }
      }, error => {
        // se revisan errores 403 - 500
        this.helperService.httpGlobalError(error);
      });
  }

  changeProveedorFilter(proveedor) {
    if(Object.keys(proveedor).length === 0){
      proveedor = null;
    }
    this.proveedor_filter = proveedor;
    this.changed_obra_or_proveedor = true;
    this.getReporte();
  }

  changeFilterObra(obra) {
    if(Object.keys(obra).length === 0){
      obra = null;
    }
    this.obra_filter = obra;
    this.changed_obra_or_proveedor = true;
    this.getProveedores(this.obra_filter,this.fecha_filter,this.fecha_filter_final);
  }

  changeFilterFecha(fecha) {
    this.fecha_filter = fecha;
    this.getReporte();
  }

  changeFilterFechaFin(fecha) {
    this.fecha_filter_final = fecha;
    this.getReporte();
  }

  changeSaldoPendienteFilter(value: boolean) {
    this.solo_saldo_pendiente = value;
    this.getReporte(); // Call getReporte to refresh data with new filter
  }

  shouldShowDeposito(deposito: any): boolean {
    if (!this.solo_saldo_pendiente) {
      return true; // Show all deposits when filter is not active
    }
    console.log(deposito);
    
    // Only show deposits of type 2 (ingresos) that have a positive balance
    //return deposito.saldo && (deposito.saldo > 0 || deposito.saldo < 0);
    return deposito.saldo && (deposito.saldo_label != "0" && deposito.saldo_label != "-0");
  }

  getProveedores(obra, fechaInicial, fechaFinal) {
    this.reporteDepositoGarantiaService.getProveedores(obra,fechaInicial,fechaFinal)
      .subscribe(response => {
        const content_response = response.json().content;
        console.log("getProveedores: ",content_response);
        this.proveedor_options = content_response;
        this.first_load = false;
        if (this.proveedor_options.length > 0) {
          this.changeProveedorFilter(this.proveedor_options[0]);
        }else{
          this.proveedor_filter = null;
          this.getReporte();
        }
      }, error => {
        this.helperService.httpGlobalError(error);
      });
  }

  getFechaActual() {
    this.reportesService.getFechaActual()
        .subscribe((response) => {
          const content = response.json().content;
          console.log("getFechaActual: ",content);
          this.fecha_actual = content.fecha;
          this.fecha_filter = content.fechaInicio;
          this.fecha_filter_final = content.fechaFinal;
          this.getObras(this.fecha_filter,this.fecha_filter_final);
        }, (error) => {
          // se revisan errores 403 - 500
          this.helperService.httpGlobalError(error);
          if (error == 400) {
            console.log('getFechasActual - error 400 ' , error);
          }
        });
  }

  // SEGURITY MODULE
  securityModule() {
    if (!this.securityActived) {
      this.securityModal.open();
    } else {
      this.authService.closeKey()
        .subscribe((response) => {
          const respuesta = response.json();
          if (respuesta.success) {
            this.getObras(this.fecha_filter,this.fecha_filter_final);
            this.securityActived = false;
            this.securityModal.push({
            'passwordActivated': false
          });
          }
        });
    }
  }

  canSecurity() {
    return this.reportesService.canSecurity();
  }

  checkSecurityKey(password) {
    this.securityModal.loading = true;
    this.reportesService.activeSecurityModule(password)
      .subscribe((response) => {
        const respuesta = response.json();
        this.securityModal.loading = false;
        if(respuesta.success === true) {
          this.getObras(this.fecha_filter,this.fecha_filter_final);
          this.securityModal.push({
            'passwordActivated': true
          });
          this.securityModal.close();
          this.securityActived = true;
        }
      }, (error) => {
        this.securityModal.loading = false;
        this.helperService.httpGlobalError(error, false);
        this.securityModal.lock();
        this.securityActived = false;
        this.securityModal.push({
          'passwordActivated': false
        });
      })
  }

  getReporte() {
    if(this.first_load){
      return
    }
    this.subscriptions.forEach((subscription: Subscription) => {
      subscription.unsubscribe();
    });
    this.loading_report = true;
    this.show_report = false;
    console.log("this.obra_filter: ",this.obra_filter);
    console.log("fecha_filter: ",this.fecha_filter);
    console.log("fecha_filter_final: ",this.fecha_filter_final);
    console.log("this.proveedor_filter: ",this.proveedor_filter);

    this.subscriptions.push(this.reporteDepositoGarantiaService.getFechaReporteGarantia(this.proveedor_filter, this.fecha_filter, this.fecha_filter_final, this.obra_filter)
    .subscribe((response) => {
      const content_response = response.json().content;
      console.log("getFechaReporteGarantia: ",content_response);
      if(this.changed_obra_or_proveedor){
        this.first_load = true;
        this.fecha_filter = content_response["fechaInicio"];
        this.fecha_filter_final = content_response["fechaFinal"];
        this.first_load = false;
      }
      
      this.subscriptions.push(this.reporteDepositoGarantiaService.getFechaReporte(this.proveedor_filter, this.fecha_filter, this.fecha_filter_final, this.obra_filter)
      .subscribe((response) => {
        const content_response = response.json().content;
        console.log("getFechaReporte: ",content_response);
        this.fechaInicialLabel = content_response["fechas"]["fechaInicialFormato"];
        this.fechaFinalLabel = content_response["fechas"]["fechaFinalFormato"];
        this.fechaGeneradoLabel = content_response["fecha_generadoFormato"];
        this.generarTotales();
      }, (error) => {
        // resuelve errores 403, 500 y sin conexión.
        this.helpersService.httpGlobalError(error);
        this.loading_report = false;
        this.show_report = false;
        this.not_report = true;
      }));

    }, (error) => {
      // resuelve errores 403, 500 y sin conexión.
      this.helpersService.httpGlobalError(error);
      this.loading_report = false;
      this.show_report = false;
      this.not_report = true;
    }));
  }

  generarTotales(){
    this.subscriptions.push(this.reporteDepositoGarantiaService.getTotales(this.proveedor_filter, this.fecha_filter, this.fecha_filter_final, this.obra_filter)
      .subscribe((response) => {
        const content_response = response.json().content;
        console.log("generarTotales: ",content_response);
        this.total_ingresos = content_response["total_ingresos_label"];
        this.total_egresos = content_response["total_egresos_label"];
        this.saldo = content_response["total_cuentas_teorico_label"];
        this.generarLista();
      }, (error) => {
        // resuelve errores 403, 500 y sin conexión.
        this.helpersService.httpGlobalError(error);
        this.loading_report = false;
        this.show_report = false;
        this.not_report = true;
      }));
  }

  generarLista(){
    this.subscriptions.push(this.reporteDepositoGarantiaService.getLista(this.proveedor_filter, this.fecha_filter, this.fecha_filter_final, this.obra_filter, this.solo_saldo_pendiente)
      .subscribe((response) => {
        const content_response = response.json().content;
        console.log("generarLista: ",content_response);
        this.lista_depositos = [];
        for(let i = 0; i < content_response.length; i++) {
          let obj = content_response[i];
          obj["tipo"] = 1; //1 es egreso
          obj["tabla"]= [];
          let objclon = JSON.parse(JSON.stringify(obj));
          objclon["tipo"] = 2; //2 es ingreso
          objclon["tabla"]= [];
          this.lista_depositos.push(obj);
          this.lista_depositos.push(objclon);
        }
        //for(let i = 0; i < this.lista_depositos.length; i++) {
          /*
          if(i % 2 == 0){
            setTimeout('3000');
            this.generarTabla(i,this.lista_depositos[i]["proveedores"],this.lista_depositos[i]["obras"],this.lista_depositos[i]["tipo"]);
          }else{
            this.generarTabla(i,this.lista_depositos[i]["proveedores"],this.lista_depositos[i]["obras"],this.lista_depositos[i]["tipo"]);
          }*/
          //this.generarTabla(i,this.lista_depositos[i]["proveedores"],this.lista_depositos[i]["obras"],this.lista_depositos[i]["tipo"]);
        //}
        let sources = [];
        for(let i = 0; i < this.lista_depositos.length; i++) {
          //
          sources.push(this.reporteDepositoGarantiaService.getTabla(this.lista_depositos[i]["proveedores"], this.fecha_filter, this.fecha_filter_final, this.lista_depositos[i]["obras"], this.lista_depositos[i]["tipo"], this.solo_saldo_pendiente));
        }
        this.subscriptions.push(forkJoin(sources).subscribe((response_list) => {
          console.log("response_list: ",response_list);
          for(let index = 0; index < response_list.length; index++) {
            let response:any = response_list[index];
            const content_response = response.json().content;
            console.log("generarTabla: ",content_response);
            this.lista_depositos[index]["tabla"] = content_response;
            let suma = 0;
            for(let i = 0; i < content_response.length; i++) {
              suma += parseFloat(content_response[i]["importe"]);
            }
            this.lista_depositos[index]["total"] = suma;
            //console.log("total: ",this.lista_depositos[index]["total"]);
            this.lista_depositos[index]["total_label"] = suma.toLocaleString();
            if(this.lista_depositos[index]["tipo"] == 1){
              this.lista_depositos[index+1]["total_label_egreso"] = suma.toLocaleString();
            }
            if(this.lista_depositos[index]["tipo"] == 2){
              //setTimeout(() => {
              console.log(parseFloat(this.lista_depositos[index]["total"]));
              console.log(parseFloat(this.lista_depositos[index-1]["total"]));
              this.lista_depositos[index]["saldo"] = parseFloat(this.lista_depositos[index]["total"]) - parseFloat(this.lista_depositos[index-1]["total"]); //ingresos - egresos
              this.lista_depositos[index]["saldo_label"] = this.lista_depositos[index]["saldo"].toLocaleString();
              this.lista_depositos[index-1]["saldo"] = this.lista_depositos[index]["saldo"];
              this.lista_depositos[index-1]["saldo_label"] = this.lista_depositos[index]["saldo_label"];
              //}, 1000);
            }
            if(index == this.lista_depositos.length-1){
              this.loading_report = false;
              this.show_report = true;
              this.not_report = false;
              this.changed_obra_or_proveedor = false;
            }
          }
        }, (error) => {
          // resuelve errores 403, 500 y sin conexión.
          this.helpersService.httpGlobalError(error);
          this.loading_report = false;
          this.show_report = false;
          this.not_report = true;
        })
        );
      }, (error) => {
        // resuelve errores 403, 500 y sin conexión.
        this.helpersService.httpGlobalError(error);
        this.loading_report = false;
        this.show_report = false;
        this.not_report = true;
      }));
  }
  //Se puede borrar en caso que funcione el forkjoin
  generarTabla(index,proveedor_filter,obra_filter,tipo_mov){
    this.subscriptions.push(this.reporteDepositoGarantiaService.getTabla(proveedor_filter, this.fecha_filter, this.fecha_filter_final, obra_filter, tipo_mov, this.solo_saldo_pendiente)
      .subscribe((response) => {
        const content_response = response.json().content;
        console.log("generarTabla: ",content_response);
        this.lista_depositos[index]["tabla"] = content_response;
        let suma = 0;
        for(let i = 0; i < content_response.length; i++) {
          suma += parseFloat(content_response[i]["importe"]);
        }
        this.lista_depositos[index]["total"] = suma;
        //console.log("total: ",this.lista_depositos[index]["total"]);
        this.lista_depositos[index]["total_label"] = suma.toLocaleString();
        if(this.lista_depositos[index]["tipo"] == 1){
          this.lista_depositos[index+1]["total_label_egreso"] = suma.toLocaleString();
        }
        if(this.lista_depositos[index]["tipo"] == 2){
          setTimeout(() => {
          console.log(parseFloat(this.lista_depositos[index]["total"]));
          console.log(parseFloat(this.lista_depositos[index-1]["total"]));
          this.lista_depositos[index]["saldo"] = parseFloat(this.lista_depositos[index]["total"]) - parseFloat(this.lista_depositos[index-1]["total"]); //ingresos - egresos
          this.lista_depositos[index]["saldo_label"] = this.lista_depositos[index]["saldo"].toLocaleString();
          }, 1000);
        }
        if(index == this.lista_depositos.length-1){
          this.loading_report = false;
          this.show_report = true;
          this.not_report = false;
          this.changed_obra_or_proveedor = false;
        }
      }, (error) => {
        // resuelve errores 403, 500 y sin conexión.
        this.helpersService.httpGlobalError(error);
        this.loading_report = false;
        this.show_report = false;
        this.not_report = true;
      }));
  }

  print() {
    this.printing = true;
    setTimeout(() => {
      window.print();
    }, 1200);
    window.onafterprint = window.onbeforeprint= () => {
      console.log('end to print');
      this.printing = false;
    };
  }

  return() {
    this.router.navigate(['/catalogo-reportes']);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/reporte-deposito-garantia/reporte-deposito-garantia.component.ts